import { collectMediaElementParams } from 'strapi/component/shared/mediaElement';
import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { BulkText } from './BulkText';
import { BulkTextProps, TextImageTextStrapiComponent } from './types';

export const collectTextImageTextComponentParams = (
  data: TextImageTextStrapiComponent
): BulkTextProps | undefined => {
  const media = collectMediaElementParams(data.media);
  if (!media) {
    return;
  }

  return {
    title: data.title,
    textBlock1: data.textBlock1,
    media: media,
    textBlock2: data.textBlock2,
    variation: data.variation ?? 'oneColumn',
  };
};

export const collectTextImageTextParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof BulkText> | undefined => {
  if (!('textImageText' in page) || !page.textImageText) {
    return undefined;
  }

  const collectedProps = collectTextImageTextComponentParams(
    page.textImageText
  );
  if (!collectedProps) {
    return;
  }

  return {
    component: ReactComponentType.TextImageText,
    props: collectedProps,
  };
};
